const COLUMNS = [
  ["household_id", "Household ID"],
  ["first_name", "Primary First Name"],
  ["last_name", "Primary Last Name"],
  ["street", "Street Including Unit"],
  ["city", "City"],
  ["state", "State"],
  ["zip", "ZIP"],
  ["full_address", "Full Address"],
  ["email", "Email"],
  ["primary_age", "Primary Age"],
  ["last_visit", "Last Visit"],
  ["reason", "Inclusion Reason"],
];

const AVERY_COLUMNS = [
  ["first_name", "First Name"],
  ["last_name", "Last Name"],
  ["street", "Street Address"],
  ["city", "City"],
  ["state", "State"],
  ["zip", "ZIP"],
];

function csvCell(value) {
  let text = value == null ? "" : String(value);
  // Leading whitespace/control characters can hide a spreadsheet formula.
  // Quote all cells, including identifiers/ZIPs; preserve commas and newlines.
  if (/^[\s\u0000-\u001f]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) {
    text = `'${text}`;
  }
  return `"${text.replace(/"/g, '""')}"`;
}

// options.checks: optional map of household_id -> {status, checked_at}.
// When given, two extra columns are appended after the original fields.
// options.format: "avery" exports only the six mail-merge fields, never checks.
export function buildMailingCsv(rows, options = {}) {
  const avery = options?.format === "avery";
  const columns = avery ? AVERY_COLUMNS : COLUMNS;
  const checks = !avery && options && options.checks;
  const extra = checks ? [["Address Check Status"], ["Address Check Time"]] : [];
  const head = [...columns.map(([, label]) => label), ...extra.map(([l]) => l)];
  return "\uFEFF" + [
    head.map(csvCell).join(","),
    ...rows.map((row) => {
      const cells = columns.map(([key]) => row[key]);
      if (checks) {
        const c = checks[row.household_id];
        cells.push(c?.status, c?.checked_at);
      }
      return cells.map(csvCell).join(",");
    }),
  ].join("\r\n") + "\r\n";
}
